import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-medication-search',
	templateUrl: './modal-medication-search.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputAutocompleteComponent, FormsModule ]
})
export class ModalMedicationSearchComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalMedicationSearchComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.initialize();
		
		this.vm.close = this.close;
		this.vm.submit = this.submit;
		this.vm.items = [];
		this.vm.formData = {};
	}
	
	initialize() {
		this.vm.handleMedicationSearch = this.handleMedicationSearch;
		this.vm.handleSelect = this.handleSelect;
		this.vm.removeItem = this.removeItem;
		
		this.vm.processing = false;
		this.vm.initialized = true;
	}
	
	submit() {
		if (this.vm.processing || !this.vm.initialized) return;
		if (!this.vm.items || this.vm.items.length == 0) {
			this.dialogRef.close(this.vm.chat);
			return;
		}
		this.vm.processing = true;
		
		var promises: Array<any> = [];
		promises.push(this.submitMedicationToChat());
		
		this.angularHelperService.getPromise().all(promises).then(
			(res) => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.NEW_MESSAGE, [res[0]], this.vm.chat.id);
				this.dialogRef.close(this.vm.chat);
			},
			(err) => {
				this.vm.processing = false;
			}
		);
	}
	
	submitMedicationToChat() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.restService.saveMedicationShare({ userId: this.vm.chat.privateChatFriend.id }, this.vm.items)
			.then((chatPost) => {
				deferred.resolve(chatPost);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	removeItem(idx) {
		this.vm.items.splice(idx, 1);
	}
	
	handleSelect = (selection: any): void => {
		this.vm.items.push(selection.selectedItem);
	}
	
	handleMedicationSearch = (searchParams: any): void => {
		var namePart = searchParams.namePart;
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.restService.getMedicationSearch({ query: namePart })
			.then((medications) => {
				medications.forEach((medication) => {
					if (medication.amount) {
						medication.fullName = medication.name + ' ' + medication.amount;
					} else {
						medication.fullName = medication.name;
					}
				});
				deferred.resolve(medications);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	close() {
		this.dialogRef.close(this.vm.chat);
	}
	
}